import React from "react";
import { I18nextProvider } from "react-i18next";
import { LanguageProvider } from "@a365/core";
import { LoaderProvider } from "@a365/dsys";
import i18n from "./i18n/i18n";
import { SwitchLanguage, SocialNetwork, Coverages } from "./components";
import "./assets/css/tailwind.generated.css";

/**
 * Wrapper que expone componentes según la prop show
 * @param {object} props
 * @param {string} props.show - "switch-language", "social-network", "coverages", "both" (switch-language + social-network)
 * @param {string} [props.customClass] - clase extra opcional
 */
export default function Root(props) {
  const {
    show = "both",
    customClass = "",
    autoOpen = false,
    onCancel,
    productId,
    productData = null,
  } = props;
  return (
    <div className={`shared-ui-wrapper ${customClass}`}>
      <I18nextProvider i18n={i18n}>
        <LanguageProvider i18nInstance={i18n}>
          <LoaderProvider>
            {(() => {
              switch (show) {
                case "switch-language":
                  return <SwitchLanguage />;
                case "social-network":
                  return <SocialNetwork />;
                case "coverages":
                  return (
                    <Coverages
                      autoOpen={autoOpen}
                      onCancel={onCancel}
                      productId={productId}
                      productData={productData}
                    />
                  );
                case "both":
                default:
                  return (
                    <>
                      <SwitchLanguage />
                      <SocialNetwork />
                    </>
                  );
              }
            })()}
          </LoaderProvider>
        </LanguageProvider>
      </I18nextProvider>
    </div>
  );
}
